import { useParams } from 'react-router-dom';
import { useTenant } from '../../lib/api';
import PipelineProgressBar from '../../components/PipelineProgressBar';

/** Customer-facing tenant overview. Intentionally sparse: tenant user +
 * domain only, plus the pipeline progress bar. No mailbox counts, no UPN
 * flip stats, no operator buttons. */
export default function UserOverview() {
  const { id = '' } = useParams();
  const { data: t } = useTenant(id);
  if (!t) return null;

  return (
    <div className="p-6 max-w-3xl space-y-4">
      <PipelineProgressBar tenant={t} />
      <div className="card p-5 space-y-3">
        <div className="text-xs uppercase tracking-wider text-dim mb-2">Tenant</div>
        <Row k="Tenant user" v={<span className="font-mono text-sm">{t.ga_upn}</span>} />
        <Row k="Domain"      v={<span className="font-mono text-sm">{t.target_domain}</span>} />
      </div>
    </div>
  );
}

function Row({ k, v }: { k: string; v: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-line/40 last:border-b-0">
      <div className="text-xs uppercase tracking-wider text-dim">{k}</div>
      <div className="text-sm">{v}</div>
    </div>
  );
}
